import { useEffect } from "react";

export const importScript = (resourceUrl) => {
  useEffect(() => {
    if (!resourceUrl) return;
    const script = document.createElement("script");
    script.src = resourceUrl;
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, [resourceUrl]);
};